import {PostsFilterQueriesType, PostsFilterStateUrlQueryNameEnum} from '../posts-filter/posts-filter-type';

export const defaultPostsQueriesValues: PostsFilterQueriesType = {
    [PostsFilterStateUrlQueryNameEnum.createdAtAfter]: '',
    [PostsFilterStateUrlQueryNameEnum.createdAtBefore]: '',
    [PostsFilterStateUrlQueryNameEnum.statuses]: '',
    [PostsFilterStateUrlQueryNameEnum.catalogs]: '',
};
